import AnalyticsIcon from '@mui/icons-material/Analytics';

const icons = {
  AnalyticsIcon
};

const agentmis = {
  id: 'agentmis',
  type: 'group',
  children: [
    {
      id: 'amis',
      title: 'Master MIS',
      type: 'item',
      url: '/agent-MIS-report',
      icon: icons.AnalyticsIcon,
    }
  ]
};

export default agentmis;
